//Modal para previsualizar los datos de un producto de URREA para confirmar que es el que se busco
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
    ModalItem,
    Form,
    FormItem,
    InputItem,
    InputNumberItem,
    HeaderItem,
    BoxItem,
    ButtonItem,
    TextAreaItem,
} from "../../../../../Components/Items";
import { Row, Col, Spin, message, Image } from "antd";

class ModalBusquedaURREA extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        fotografia: null,
    };


    componentDidUpdate(prevProps) {

        if (prevProps.visible !== this.props.visible && this.props.visible) {
            this.setState({ loading: true });
            this.consultarInsumoURREA(this.props.codigoURREA)

        }
    }

    consultarInsumoURREA(value) {

        axios
            .post("/insumos/consultaInformacionProductoURREA",
                {
                    empresaId: this.props.empresaId,
                    codigo: value
                },
                { headersToken: this.props.headersToken }
            )
            .then((res) => {
                const data = res.data.data[0];
                const costo =  (data.Precio * 0.8) * 0.86;
                this.formRef.current.setFieldsValue({
                    codigo: data.codigo,
                    codigoBarras: data.CodigoBarras,
                    descripcion: data.DescripcionProducto,
                    descripcionLarga: data.bullets,
                    marca: data.Marca,
                    unidad: data.claveUnidadSAT,
                    anexoSat: data.anexo20SAT,
                    costo: costo
                })
                //fotografia
                this.setState({ fotografia: data.fotografia });

            })
            .finally(() => {
                this.setState({ loading: false });
            });

    }
    atras() {
        // Limpiar el formulario al cerrar
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }

        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    onFinishFailed(e) {
        message.error("Verifica los campos obligatorios.");
    }

    onFinish(values) {
        const dataConFoto = { ...values, fotografia: this.state.fotografia };
        if (this.props.onConfirm) {
            this.props.onConfirm(dataConFoto);
        }
        this.atras(); // cerrar
    }

    render() {
        return (
            <ModalItem
                title="Previsualización Insumo URREA"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.atras.bind(this)}
                paddingTop
                width={800}
            >

                <Spin spinning={this.state.loading}>
                    <Form
                        ref={this.formRef}
                        name="guardarInformacionURREA"
                        layout
                        bottom={
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                                <ButtonItem
                                    type="default"
                                    naranja
                                    onClick={() => {
                                        if (this.props.onConfirm) {
                                            this.props.onConfirm(null); // mandar nada
                                        }
                                        this.atras();
                                    }}
                                >
                                    No es este
                                </ButtonItem>

                                <ButtonItem type="primary" htmlType="submit">
                                    Guardar
                                </ButtonItem>
                            </div>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <HeaderItem>DATOS DEL INSUMO BUSCADO</HeaderItem>
                        <BoxItem>
                            <Row>
                                <Col span={10} >
                                    <FormItem
                                        label="Código"
                                        name="codigo"
                                        required
                                        margin
                                    >
                                        <InputNumberItem placeholder="Código" disabled={true} />
                                    </FormItem>

                                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                                        <Image
                                            width={200}
                                            src={this.state.fotografia}
                                            alt="Fotografía del Insumo"
                                            fallback="https://via.placeholder.com/200x200?text=Sin+imagen"
                                            style={{
                                                border: "1px solid #d9d9d9",
                                                borderRadius: "8px",
                                                padding: "4px",
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col span={14}>

                                    <FormItem
                                        label="Código de Barras"
                                        name="codigoBarras"
                                        required
                                        margin
                                        number
                                    >
                                        <InputNumberItem placeholder="Código de Barras" disabled={true} />
                                    </FormItem>
                                    <FormItem
                                        label="Descripción"
                                        name="descripcion"
                                        required
                                        margin
                                    >
                                        <InputItem placeholder="Descripción" disabled={true} />
                                    </FormItem>
                                    <FormItem
                                        label="Descripción Larga"
                                        name="descripcionLarga"
                                        required
                                        margin
                                    >
                                        <TextAreaItem placeholder="Descripción Larga" disabled={true} />
                                    </FormItem>
                                    <FormItem
                                        label="Marca"
                                        name="marca"
                                        required
                                        margin

                                    >
                                        <InputItem placeholder="Marca" disabled={true} />
                                    </FormItem>

                                    <FormItem
                                        label="Unidad"
                                        name="unidad"
                                        required
                                        margin

                                    >
                                        <InputItem placeholder="Unidad" disabled={true} />
                                    </FormItem>
                                    <FormItem
                                        label="Anexo SAT"
                                        name="anexoSat"
                                        required
                                        margin
                                    >
                                        <InputNumberItem placeholder="Anexo SAT" disabled={true} />
                                    </FormItem>
                                    
                                    <FormItem
                                        label="Costo"
                                        name="costo"
                                        required
                                        margin

                                    >
                                        <InputItem placeholder="Costo" disabled={true} />
                                    </FormItem>
                                </Col>

                            </Row>
                        </BoxItem>
                    </Form>
                </Spin>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa?.id,
});

export default connect(mapStateToProps)(ModalBusquedaURREA);